import { selectTrackingPromoDetailsById } from '../../selectors/tracking';
import { TThunkAction } from '../../types/redux/thunk';
import { trackPromoLinkClick } from '../../utils/analytics';

/**
 * Redux thunk action, который отправляет аналитику события открытия ссылки из модалки акции.
 */
export const trackPromoLinkClickAction = (
  id: string,
  label: 'to_offers' | 'to_jk' | 'to_listingjk',
): TThunkAction<void> => {
  return (_dispatch, getState) => {
    const state = getState();
    const params = selectTrackingPromoDetailsById(id)(state);

    trackPromoLinkClick({
      ...params,
      label,
    });
  };
};
